import React from 'react';
import { /*FaGithub,*/ FaLinkedin, /*FaTwitter,*/ FaXing } from 'react-icons/fa';
import { SiFreelancer } from "react-icons/si";
import { useLanguage } from '../../context/LanguageContext';
import { useDialog } from '../../context/DialogContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const { toggleImpressum, toggleDatenschutz } = useDialog();

  return (
    <footer className="bg-white/85 dark:bg-gray-800/85 border-t border-gray-200/50 dark:border-gray-700/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto py-6 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav className="flex justify-center space-x-6" aria-label="Footer">
          {/*<a
            href="https://github.com/yourusername"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            aria-label="GitHub"
          >
            <span className="sr-only">GitHub</span>
            <FaGithub className="h-6 w-6" />
          </a>*/}
          <a
            href="https://www.linkedin.com/in/matthias-bauer-00881333/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            aria-label="LinkedIn"
          >
            <span className="sr-only">LinkedIn</span>
            <FaLinkedin className="h-6 w-6" />
          </a>
          <a
            href="https://www.xing.com/profile/Matthias_Bauer131"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            aria-label="Xing"
          >
            <span className="sr-only">Xing</span>
            <FaXing className="h-6 w-6" />
          </a>
          <a
            href="https://www.freelancermap.de/profil/softwareentwickler-im-bereich-web-development"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            aria-label="Freelancermap"
          >
            <span className="sr-only">Freelancermap</span>
            <SiFreelancer className="h-6 w-6" />
          </a>
          {/*<a href="https://www.freelancermap.de/profil/softwareentwickler-im-bereich-web-development" target="_blank" title="Profil von Matthias Bauer auf www.freelancermap.de">
            <img loading="lazy" style={{width: "118px", height: "24px"}} src="https://www.freelancermap.de/assets/logo/logo-black.svg" alt="Freelancermap Badge"/>
          </a>*/}
          {/*<a
            href="https://twitter.com/yourusername"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            aria-label="Twitter"
          >
            <span className="sr-only">Twitter</span>
            <FaTwitter className="h-6 w-6" />
          </a>*/}
        </nav>
        <div className="mt-6 text-center space-y-2">
          <p className="text-base text-gray-500 dark:text-gray-400">
            {t('footer.copyright')}
          </p>
          <div className="flex justify-center space-x-4 text-sm">
            <button
              onClick={toggleImpressum}
              className="text-gray-500 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.impressum')}
            </button>
            <span className="text-gray-400 dark:text-gray-600">|</span>
            <button
              onClick={toggleDatenschutz}
              className="text-gray-500 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.privacy')}
            </button>
          </div>
        </div>
        
        {/* Dialogs are now rendered at the root level in App.tsx */}
      </div>
    </footer>
  );
};

export default Footer;
